import {useEffect,useState} from 'react';
import {useLocation} from 'react-router-dom';
import {useAuth} from '../lib/auth';
import {api} from '../lib/api';
import AtlasPublic from './AtlasPublic';

// Detailed presentation is available after access activation or through an
// existing valid invitation. Validation never consumes the invitation.
export default function PublicProductRoute({children,invitation=false}){
 const {user,loading}=useAuth(),location=useLocation();
 const code=invitation?new URLSearchParams(location.search).get('invite'):null;
 const [checked,setChecked]=useState(null);
 useEffect(()=>{let alive=true;setChecked(null);if(!code)return;api.get('/public/auth/invite-check',{params:{code}}).then(r=>{if(alive)setChecked({code,valid:r.data.valid===true});}).catch(()=>{if(alive)setChecked({code,valid:false});});return()=>{alive=false;};},[code]);
 const allowed=user?.is_admin||(user?.is_practitioner&&user?.practitioner_status==='active');
 if(loading||(!allowed&&code&&checked?.code!==code))return <div role="status" className="min-h-screen bg-pt-bg p-12 text-pt-tdim">Loading…</div>;
 if(allowed||(code&&checked?.code===code&&checked.valid))return children;
 return <AtlasPublic/>;
}
